import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './index.scss'
import {
    Form,
    Input,
    Tabs,
    Space,
    Button,
    message
} from 'antd';
import {
    RightCircleFilled
} from '@ant-design/icons';
import { user } from '../../service';
import { useDispatch } from 'react-redux';
import { setToken } from '../../store/modules/token';
import { setBasic } from '../../store/modules/basic';



export default function LoginView() {
    const navigate = useNavigate()
        , dispatch = useDispatch()
        , [form] = Form.useForm()
        , [form2] = Form.useForm()
        , [countdown, setCountdown] = useState(0)
        , [loading, setLoading] = useState(false)

    const handleSendCodeClick = () => {
        // 请求成功后倒计时为60秒，并开始倒计时
        if (countdown === 0) {

            console.log('发送验证码');
            setCountdown(60);

            // 倒计时
            const timer = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown > 0) {
                        return prevCountdown - 1;
                    } else {
                        clearInterval(timer);
                        return 0;
                    }
                });
            }, 1000);
        } else {
            message.warning('请等待倒计时结束后再重新发送验证码。');
        }
    };


    //  账号密码登录
    const onPwdLogin = async () => {
        const value = await form.validateFields()
        try {
            setLoading(true)
            // 用户登录
            const { data } = await user.login(value)
            dispatch(setToken({ token: data.token }))

            //  获取基本信息
            const basic = await user.getBasicInfo()
            const res = await user.getCompanyInfo()
            dispatch(setBasic({ ...basic.data, companyName: res.data && res.data.companyName }))

            message.success('登录成功！')
            navigate('/')
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }

    }

    // 验证码登录
    const onVerifyLogin = async () => {
        const value = await form2.validateFields()
        console.log(value);
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }

    return (
        <div className='login-container'>
            <div className='title color-primary' onClick={() => navigate('/')}>有农社会化服务管理平台</div>
            <div className='login-box'>
                {/* <Tabs
                    defaultActiveKey="1"
                    centered={true}
                    items={[
                        {
                            key: '1',
                            label: '账号密码',
                            children: (
                                <Form
                                    form={form}
                                    component={false}
                                    name="login.form"
                                    labelCol={{ span: 5 }}
                                >
                                    <Form.Item
                                        name='phone'
                                        label="账号"
                                        rules={[{ required: true, message: '请输入账号' }]}
                                    >
                                        <Input size='large' placeholder={`请输入账号`} />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        label="密码"
                                        rules={[{ required: true, message: '请输入密码' }]}
                                    >
                                        <Input.Password size='large' placeholder={`请输入密码`} />
                                    </Form.Item>

                                    <Form.Item>
                                        <Button
                                            type='primary'
                                            block
                                            size='large'
                                            style={{ marginTop: '20px' }}
                                            onClick={onPwdLogin}
                                            loading={loading}
                                        >立即登录</Button>
                                    </Form.Item>
                                </Form>
                            )
                        },
                        {
                            key: '2',
                            label: '验证码',
                            children: (
                                <Form
                                    form={form2}
                                    component={false}
                                    name="login.form"
                                    labelCol={{ span: 5 }}
                                >
                                    <Form.Item
                                        name='phone'
                                        label="手机号"
                                        rules={[{ required: true, message: '请输入手机号' }]}
                                    >
                                        <Input size='large' placeholder={`请输入手机号`} />
                                    </Form.Item>

                                    <Form.Item
                                        name="verificationCode"
                                        label="验证码"
                                        rules={[{ required: true, message: '请输入验证码' }]}
                                        wrapperCol={{ span: 19 }}
                                    >

                                        <Space.Compact
                                            size="large"
                                        >
                                            <Input placeholder="请输入验证码" />
                                            <Button
                                                type="primary"
                                                onClick={handleSendCodeClick}
                                                disabled={countdown > 0}
                                            >
                                                {countdown > 0 ? `重新获取(${countdown})` : '发送验证码'}
                                            </Button>
                                        </Space.Compact>
                                    </Form.Item>

                                    <Form.Item>
                                        <Button
                                            type='primary'
                                            block
                                            size='large'
                                            style={{ marginTop: '20px' }}
                                            loading={loading}
                                            onClick={onVerifyLogin}
                                        >立即登录</Button>
                                    </Form.Item>
                                </Form>
                            )
                        }
                    ]}
                /> */}

                <Form
                    form={form}
                    name="login.form"
                    labelCol={{ span: 5 }}
                    onFinish={onPwdLogin}
                >
                    <Form.Item
                        name='name'
                        label="账号"
                        rules={[{ required: true, message: '请输入账号' }]}
                        style={{ marginTop: '30px' }}
                    >
                        <Input size='large' placeholder={`请输入账号`} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input.Password size='large' placeholder={`请输入密码`} />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type='primary'
                            block
                            size='large'
                            style={{ marginTop: '20px' }}
                            htmlType="submit"
                            loading={loading}
                        >立即登录</Button>
                    </Form.Item>
                </Form>

                <div
                    className='goregister'
                >
                    <Button
                        type="text"
                        onClick={() => navigate(`/reset`)}
                        className='color-primary'
                    >
                        重置密码
                    </Button>

                    <Button
                        type="text"
                        icon={<RightCircleFilled className='right-circle color-primary' />}
                        onClick={() => navigate(`/register`)}
                    >
                        立即注册
                    </Button>
                </div>
            </div>
        </div>
    )

}
